import * as React from "react";
import useCheckout from "../../../../../../../../../../hooks/adyen/hooks/adyen/useCheckout.js";
import { PaymentMethodFormContainer } from "../../../../../../PaymentMethodForm/containers/modules/PaymentMethodsList/containers/Adyen/PaymentMethodForm/containers/PaymentMethodFormContainer.js";
import { AdyenPaymentType } from "../../../../../../../../../../models/adyen/models/adyen/payment-type.js";
const toPaymentMethodFormState = (state) => ({
  isValid: state.isValid,
  data: {
    "sepa.ownerName": state.data.paymentMethod.ownerName ?? "",
    "sepa.ibanNumber": state.data.paymentMethod.iban ?? ""
  }
});
const SepaContainer = ({ onChange }) => {
  const setSepaState = React.useCallback(
    (state) => onChange(toPaymentMethodFormState(state)),
    [onChange]
  );
  const checkout = useCheckout(setSepaState);
  return /* @__PURE__ */ React.createElement(PaymentMethodFormContainer, { type: AdyenPaymentType.Sepa, checkout });
};
export {
  SepaContainer
};
//# sourceMappingURL=SepaContainer.js.map
